<SettingsLayout page='settings/about' label="Acerca de Pinafore">
  <div>
    <h1>Acerca de Pinafore</h1>

    <h2>Version {version}</h2>

    {@html "<p> Pinafore es <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/nolanlawson/pinafore\">software libre y de código abierto</a> creado por <a rel=\"noopener\" target=\"_blank\" href=\"https://nolanlawson.com\">Nolan Lawson</a> y distribuido bajo la <a rel=\"noopener\" target=\"_blank\" href=\"https://github.com/nolanlawson/pinafore/blob/master/LICENSE\">GNU Affero General Public License</a>. </p> <h2 id=\"privacy-policy\">Política de privacidad</h2> <p> Pinafore no almacena ninguna información personal en sus servidores, incluyendo, pero no limitándose a nombres, direcciones de correo electrónico, direcciones IP, posts y fotos. </p> <p> Pinafore es un sitio estático. Todos los datos son almacenados en tu navegador y compartidos con las instancias del fediverso a las que te conectas. </p> <h2>Créditos</h2> <p> Iconos proporcionados por <a rel=\"noopener\" target=\"_blank\" href=\"http://fontawesome.io/\">Font Awesome</a>. </p> <p> Logo gracias a \"sailboat\" por Gregor Cresnar, de <a rel=\"noopener\" target=\"_blank\" href=\"https://thenounproject.com/\">the Noun Project</a>. </p>"}
  </div>
</SettingsLayout>
<script>
  import SettingsLayout from '../../_components/settings/SettingsLayout.html'

  const version = process.env.PINAFORE_VERSION

  export default {
    components: {
      SettingsLayout
    },
    data: () => ({
      version
    })
  }
</script>
